const BASE_URL = '/'

// Auth routes
const INVITE_ACCEPT_URL = `${BASE_URL}invitation/:inviteId/accept`
const SIGN_UP_URL = `${BASE_URL}sign-up`
const MASTER_CONTRACTORS_SIGN_UP_URL = `${BASE_URL}master-contractor-sign-up`
const SIGN_IN_URL = `${BASE_URL}sign-in`
const SIGN_IN_AS_URL = `${BASE_URL}sign-in-as`
const FORGOT_PASSWORD_URL = `${BASE_URL}forgot-password`
const FORGOT_PASSWORD_LINK_SENT_URL = `${BASE_URL}forgot-password-sent`
const RESET_PASSWORD_URL = `${BASE_URL}password-reset`

// Customer routes
const CUSTOMER_ONBOARDING_URL = `${BASE_URL}onboarding`
const CUSTOMER_RESUBMIT_INFO_URL = `${BASE_URL}resubmit-info`
const CUSTOMER_COMPLIANCE_URL = `${BASE_URL}compliance`

const COMPLETE_GIGSAFE_SIGNING_URL = `${BASE_URL}complete-gigsafe-signing`

// App routes
const CONTRACTOR_ONBOARDINGS_URL = `${BASE_URL}contractors-onboarding`
const CONTRACTORS_URL = `${BASE_URL}contractors`
const PRIORITY_QUEUE_URL = `${BASE_URL}priority-queue`

const OPPORTUNITIES_URL = `${BASE_URL}opportunities`
const CANDIDATE_POOL_URL = `${BASE_URL}candidate-pool`

const MASTER_CONTRACTOR_ONBOARDINGS_URL = `${BASE_URL}master-contractors-onboarding`
const MASTER_CONTRACTORS_URL = `${BASE_URL}master-contractors`

const MASTER_CONTRACTOR_ACCEPT_INVITE_URL = `${BASE_URL}master-contractor-accept-invite`

const PAYMENTS_URL = `${BASE_URL}payments`
const TEAM_URL = `${BASE_URL}team`
const REQUESTS_URL = `${BASE_URL}requests`
const LINK_TO_CUSTOMER_URL = `${BASE_URL}link-to-customer`

const SETTINGS_URL = `${BASE_URL}settings`
const SETTINGS_NOTIFICATIONS_URL = `${BASE_URL}settings/notifications`
const SETTINGS_DECLINE_REASONS_URL = `${BASE_URL}settings/decline-reasons`
const SETTINGS_PERSONAL_ACCESS_TOKENS_URL = `${BASE_URL}settings/personal-access-tokens`

const SUCCESS_URL = `${BASE_URL}success`
const NOT_FOUND_URL = `${BASE_URL}not-found`
const LOGGED_OUT_URL = `${BASE_URL}logged-out`

export const ROUTES = {
  BASE_URL,

  INVITE_ACCEPT_URL,
  SIGN_UP_URL,
  MASTER_CONTRACTORS_SIGN_UP_URL,
  SIGN_IN_URL,
  SIGN_IN_AS_URL,
  FORGOT_PASSWORD_URL,
  FORGOT_PASSWORD_LINK_SENT_URL,
  RESET_PASSWORD_URL,

  CUSTOMER_ONBOARDING_URL,
  CUSTOMER_RESUBMIT_INFO_URL,
  CUSTOMER_COMPLIANCE_URL,

  COMPLETE_GIGSAFE_SIGNING_URL,

  CONTRACTOR_ONBOARDINGS_URL,
  CONTRACTORS_URL,
  PRIORITY_QUEUE_URL,
  OPPORTUNITIES_URL,
  CANDIDATE_POOL_URL,
  PAYMENTS_URL,

  MASTER_CONTRACTOR_ONBOARDINGS_URL,
  MASTER_CONTRACTORS_URL,

  MASTER_CONTRACTOR_ACCEPT_INVITE_URL,

  TEAM_URL,
  LINK_TO_CUSTOMER_URL,
  REQUESTS_URL,

  SETTINGS_URL,
  SETTINGS_NOTIFICATIONS_URL,
  SETTINGS_DECLINE_REASONS_URL,
  SETTINGS_PERSONAL_ACCESS_TOKENS_URL,

  SUCCESS_URL,
  NOT_FOUND_URL,
  LOGGED_OUT_URL,
}
